// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2-Vl0","right":"Footer_right__295zX","buttons":"Footer_buttons__1qTu5"};